<template>
  <div class="survey-links-panel">
    <v-row>
      <v-col cols="12" sm="6" md="8">
        <DsfrSearchField
          v-model="searchTerm"
          placeholder="Rechercher par nom de cantine"
          hide-details
          clearable
          :clearAction="clearSearch"
          :searchAction="search"
          label="Rechercher par nom de cantine"
        />
      </v-col>
    </v-row>

    <div v-if="loading" class="mt-8">
      <v-progress-circular indeterminate aria-label="Chargement des enquêtes"></v-progress-circular>
    </div>

    <div v-else-if="surveyLinksCount === 0" class="d-flex flex-column align-center py-10">
      <v-icon large aria-hidden="true">mdi-inbox-remove</v-icon>
      <p class="text-body-1 grey--text text--darken-1 my-2">
        {{ searchTerm ? "Cette recherche n'a pas permis de trouver d'enquête" : "Aucune enquête disponible" }}
      </p>
    </div>

    <div v-else>
      <DsfrPagination class="my-6" v-model="page" :length="pageCount" />
      <v-row class="cta-group pa-2 mt-2">
        <v-col cols="12" sm="6" md="4" v-for="link in currentPageLinks" :key="link.id">
          <SurveyLinkCard :link="link" />
        </v-col>
      </v-row>
      <DsfrPagination class="my-6" v-model="page" :length="pageCount" v-if="$vuetify.breakpoint.smAndDown" />
    </div>
  </div>
</template>

<script>
import SurveyLinkCard from "./SurveyLinkCard"
import DsfrPagination from "@/components/DsfrPagination"
import DsfrSearchField from "@/components/DsfrSearchField"

/**
 * Liste des questionnaires (recherche + pagination), sans chrome de page.
 *
 * Extrait de `SurveyLinksHome` pour être montable ailleurs — en particulier dans la
 * card modale « Mes avis » du dashboard convive — sans traîner le fil d'Ariane ni le
 * titre `<h1>` de la page, qui dupliquerait la hiérarchie de titres de l'hôte (RGAA).
 * `SurveyLinksHome` reste la page autonome et délègue son contenu à ce panneau.
 */
export default {
  name: "SurveyLinksPanel",
  components: { SurveyLinkCard, DsfrPagination, DsfrSearchField },
  data() {
    return {
      limit: 6,
      page: 1,
      surveyLinks: null,
      searchTerm: null,
    }
  },
  computed: {
    loading() {
      return this.surveyLinks === null
    },
    surveyLinksCount() {
      return this.surveyLinks ? this.surveyLinks.length : 0
    },
    pageCount() {
      return Math.ceil(this.surveyLinksCount / this.limit)
    },
    offset() {
      return (this.page - 1) * this.limit
    },
    currentPageLinks() {
      if (!this.surveyLinks) return []
      return this.surveyLinks.slice(this.offset, this.offset + this.limit)
    },
  },
  methods: {
    search() {
      this.page = 1
      this.fetchSurveyLinks()
    },
    fetchSurveyLinks() {
      this.surveyLinks = null
      this.$store
        .dispatch("fetchSurveyLinks", { offset: 0, search: this.searchTerm })
        .then((response) => {
          this.surveyLinks = response || []
        })
        .catch(() => {
          this.surveyLinks = []
          this.$store.dispatch("notifyServerError")
        })
    },
    clearSearch() {
      this.searchTerm = ""
      this.search()
    },
  },
  mounted() {
    this.fetchSurveyLinks()
  },
}
</script>
